import axiosInstance from "../../translator";
import { b2c, machineCatalogueAPI } from "../../constants/apis/apiEndpoints";

export const fetchPlanList = async (urlParams) => {
  return axiosInstance
    .get(`${b2c?.plan}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchRetrievePlanList = async (urlParams) => {
  return axiosInstance
    .get(`${b2c?.planMapping}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updateCatalogPlan = async (id, data) => {
  return axiosInstance
    .put(`${b2c?.planMapping}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createPlanList = async (data) => {
  return axiosInstance
    .post(`${b2c?.plan}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const createFreeTrialTemplate = async (id, data) => {
  return axiosInstance
    .put(`${b2c?.freeTrial}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deletePlanApi = async (id) => {
  return axiosInstance
    .delete(`${b2c?.plan}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const updatePlanApi = async (id, data) => {
  return axiosInstance
    .put(`${b2c?.plan}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getB2cCatalogsListApi = async (urlParams) => {
  return axiosInstance
    .get(`${b2c?.b2cCatalog}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getB2CLatestPurchasesApi = async (urlParams) => {
  return axiosInstance
    .get(`${b2c?.latestPurchases}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getB2CDashTrendingLabsApi = async (urlParams) => {
  return axiosInstance
    .get(`${b2c?.b2cCatalog}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getB2CVmLabsApi = async (urlParams) => {
  return axiosInstance
    .get(`${b2c?.b2cVmLabs}${urlParams}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const addLabIntoCartApi = async (data) => {
  return axiosInstance
    .post(`${b2c?.addIntoCart}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const getUserCartDetailsApi = async (id) => {
  return axiosInstance
    .get(`${b2c?.addIntoCart}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const deleteItemToCartApi = async (id) => {
  return axiosInstance
    .delete(`${b2c?.addIntoCart}/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const b2cCheckoutApi = async (data) => {
  return axiosInstance
    .post(`${b2c?.checkout}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const paymentCallbackApi = async (data) => {
  return axiosInstance
    .post(`${b2c?.paymentCallback}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const paymentReceiptApi = async (id) => {
  return axiosInstance
    .get(`${b2c?.paymentReceipt}?payment_id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const applyDiscountApi = async (id, data) => {
  return axiosInstance
    .patch(`${machineCatalogueAPI.catalogues}/${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
